<template>
  <v-container>
    <v-card outlined>
      <v-card-text>
        <div v-if="loading">Loading PDF...</div>
        <div v-else >
          <div class="canvas-wrapper">
            <canvas ref="pdfCanvas"></canvas>
          </div>
          <div class="text-center mt-4">
            <v-btn @click="prevPage" :disabled="currentPage <= 1">Previous</v-btn>
            <span class="mx-4">Page {{ currentPage }} / {{ totalPages }}</span>
            <v-btn @click="nextPage" :disabled="currentPage >= totalPages">Next</v-btn>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import * as pdfjsLib from 'pdfjs-dist';
import pdfWorker from 'pdfjs-dist/build/pdf.worker.entry';

pdfjsLib.GlobalWorkerOptions.workerSrc = pdfWorker;

export default {
  props: {
    pdfUrl: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      pdfDoc: null,
      currentPage: 1,
      totalPages: 0,
      scale: 1.5,
      loading: true
    };
  },
  async mounted() {
    await this.loadPdf();
  },
  methods: {
    async loadPdf() {
      try {
        const loadingTask = pdfjsLib.getDocument(this.pdfUrl);
        this.pdfDoc = await loadingTask.promise;
        this.totalPages = this.pdfDoc.numPages;
        this.loading = false;
        this.$nextTick(() => {
          this.renderPage(this.currentPage);
        });
      } catch (error) {
        console.error("Error loading PDF:", error);
      }
    },
    async renderPage(pageNumber) {
      if (!this.pdfDoc) return;

      const canvas = this.$refs.pdfCanvas;
      if (!canvas) {
        console.error("Canvas not yet rendered");
        return;
      }

      const context = canvas.getContext("2d");

      const dpr = window.devicePixelRatio || 2;
      const baseScale = 1.8; // Zoom level
      const viewport = (await this.pdfDoc.getPage(pageNumber)).getViewport({
        scale: baseScale * dpr
      });

      canvas.width = viewport.width;
      canvas.height = viewport.height;

      // Set responsive CSS size
      canvas.style.width = "100%";
      canvas.style.height = "auto";
      canvas.style.maxWidth = `${viewport.width / dpr}px`;

      const renderContext = {
        canvasContext: context,
        viewport
      };

      await this.pdfDoc.getPage(pageNumber).then(page =>
        page.render(renderContext).promise
      );
    },


    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.$nextTick(() => {
          this.renderPage(this.currentPage);
        });
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.$nextTick(() => {
          this.renderPage(this.currentPage);
        });
      }
    }
  }
};
</script>

<style scoped>
.canvas-wrapper {
  display: flex;
  justify-content: center;
  overflow-x: auto;
  padding: 0 8px;
}

canvas {
  display: block;
  border: 1px solid #ccc;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  user-select: none;
  pointer-events: none;
  width: 100%;
  height: auto;
  max-width: 100%; /* Prevents overflow */
}


</style>
